import { Module } from '@/types/module'
import { Step } from '@/types/step'
import { User } from '@/types/user'

import { getRouteByConditions } from '../route'

export const getInitialStep = ({ module, user }: { module: Module; user: User }): Step => {
  const { routeConditions: userConditions } = user
  const { initialSteps, steps } = module

  // User has no route conditions: return the first step with no conditions
  if (!userConditions) {
    const stepId = initialSteps.find((initialStep) => !initialStep.conditions)?.route.step

    if (!stepId || !steps[stepId]) throw new Error(`No initial step ${stepId} found WITHOUT conditions`)

    return steps[stepId]
  }

  const initialStep = getRouteByConditions({ userConditions, routes: initialSteps })

  const stepId = initialStep?.route.step

  if (!stepId || !steps[stepId]) throw new Error(`No initial step ${stepId} found WITH conditions`)

  return steps[stepId]
}
